import Cookies from "js-cookie"
import { environment } from "@/env/env.prod"

export const apiHeaders = () => ({
    "Content-Type": "application/json",
    "Authorization": `Bearer ${Cookies.get("authToken")}`,
    "X-INSTITUTE": Cookies.get("ins_code") || "",
    "X-E-ID": Cookies.get("E_id") || "",
    "X-FACULTY": "1",
    "X-PARENT": Cookies.get("ins_code") || ""
})